import { render, staticRenderFns } from "./chinaschool.vue?vue&type=template&id=339f78a4"
import script from "./chinaschool.vue?vue&type=script&lang=js"
export * from "./chinaschool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports